import React from 'react';

import { EVENT_SHEET_TITLE_HEIGHT } from '@/components/event-sheet/EventSheetTitle';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Handle, MODAL_HANDLE_HEIGHT } from '@/feature/alerts/components/Modal';
import { PlayerWithTeamAndEvent } from '@/feature/betslip-pickem/types';
import { CircularPagerSheetHandleGestureWrapper } from '@/feature/circular-pager/BottomSheetCircularPagerWrapper';
import { PlayerProfileTitleWithScrollableModal } from '@/feature/player-profile-sheets/components/PlayerProfileTitle';
import { common, withOpacity } from '@/styles/styles';

export const PlayerProfileSheetHandle = ({ playerInfo }: { playerInfo: PlayerWithTeamAndEvent }) => {
    return (
        <CircularPagerSheetHandleGestureWrapper>
            <Box
                position={'absolute'}
                zIndex={1}
                width={'100%'}
                height={EVENT_SHEET_TITLE_HEIGHT + MODAL_HANDLE_HEIGHT}
                overflow={'hidden'}
            >
                <Box style={common.flex}>
                    <Handle
                        handleColor={withOpacity(ds.colorValue.background.neutral.inverse, 0.15)}
                        handleContainerStyle={common.backgroundColorTransparent}
                    />
                    <PlayerProfileTitleWithScrollableModal playerInfo={playerInfo} />
                </Box>
            </Box>
        </CircularPagerSheetHandleGestureWrapper>
    );
};
